export default {

  /* ----------------------------------------------- */
  /* ------------------- Varie -------------------- */
  /* ----------------------------------------------- */
  getErrorMsg(err) {
    // NOTA: err.response undefined -> quando non c'è la rete
    //       "data" è vuoto -> quando la pagina non è trovata (404) 
    //       quando da Api non passo "message" prendo "data"
    //       data.error_description -> asp mvc owin
    //       data.Message -> asp mvc 
    //       data.message -> .net core

    return (err.response && err.response.data ? (err.response.data.error_description || err.response.data.message || err.response.data.Message || err.response.data) : err.message)
  },


  checkAmbienteTest(urlApi) {
    return urlApi.includes(":82")
  },

  isDebug() {
    return process.env.NODE_ENV === "development"
  },

  CordovaApp() {
    return !!window.cordova
  },



  /* ----------------------------------------------- */
  /* ----------------- File / Blob ----------------- */
  /* ----------------------------------------------- */
  getExtensionFile(fileName) {
    return fileName.substr(fileName.lastIndexOf('.'));
  },

  getFileName(path) {
    return path.replace(/^.*[\\\/]/, "");
  },

  openWindowWithPost(url, data) {
    var form = document.createElement("form");
    form.target = "_blank";
    form.method = "POST";
    form.action = url;
    form.style.display = "none";

    for (var key in data) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = data[key];
      form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  },

  createBlobPdf(data) {
    let blob = new Blob([data], { type: "application/pdf" });

    // NOTA: edge non supporta createObjectURL
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob);
    } else {
      var objectUrl = URL.createObjectURL(blob);
      window.open(objectUrl);
    }
  },

  openPdfBlob(data) {
    let blob = new Blob([data], { type: "application/pdf" });
    let url = window.URL.createObjectURL(blob);
    window.open(url, "_blank");
  },

  downloadFileBlob(data, fileName) {
    let blob = new Blob([data]);
    let url = window.URL.createObjectURL(blob);

    this.downloadFile(url, fileName)
  },

  downloadFile(url, fileName) {
    var element = document.createElement('a');
    element.href = url;

    element.setAttribute("download", fileName);

    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  },



  /* ----------------------------------------------- */
  /* ------------------- Array --------------------- */
  /* ----------------------------------------------- */
  groupBy(array, key) {
    const result = {};
    array.forEach(item => {
      if (!result[item[key]]) {
        result[item[key]] = [];
      }
      result[item[key]].push(item);
    });
    return result;
  },

  groupByIndex(array, key) {

    let res = this.groupBy(array, key)

    return Object.keys(res).map(function (key) {
      return {
        key: key,
        values: res[key]
      };
    });
  },

  isSmartphone() {
    let check = false;
    // eslint-disable-next-line no-useless-escape
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check && window.innerWidth <= 460;
  },

  isMobile() {
    let check = false;
    // eslint-disable-next-line no-useless-escape
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  },



  /* ----------------------------------------------- */
  /* ------------------ Validazioni ---------------- */
  /* ----------------------------------------------- */
  checkNumber(evt) {
    var theEvent = evt || window.event;

    // Handle paste
    if (theEvent.type === "paste") {
      key = event.clipboardData.getData("text/plain");
    } else {
      // Handle key press
      var key = theEvent.keyCode || theEvent.which;
      key = String.fromCharCode(key);
    }
    var regex = /[0-9]|\./;
    if (!regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  },

  isNumber(str) {
    // NOTA: nel caso sia zero viene considerato come false
    if (!str && str.toString() != "0")
      return false

    if (this.trimAll(str).length == 0)
      return false

    return true

  },

  ValidateDate(dateValue) {
    var selectedDate = dateValue;
    if (!selectedDate || selectedDate == '')
      return false;

    var regExp = /^(\d{1,2})(\/|-)(\d{1,2})(\/|-)(\d{4})$/; //Declare Regex
    var dateArray = selectedDate.match(regExp); // is format OK?

    if (dateArray == null) {
      return false;
    }

    let day = dateArray[1];
    let month = dateArray[3];
    let year = dateArray[5];

    if (month < 1 || month > 12) {
      return false;
    } else if (day < 1 || day > 31) {
      return false;
    } else if ((month == 4 || month == 6 || month == 9 || month == 11) && day == 31) {
      return false;
    } else if (month == 2) {
      var isLeapYear = (year % 4 == 0 && (year % 100 != 0 || year % 400 == 0));
      if (day > 29 || (day == 29 && !isLeapYear)) {
        return false
      }
    }
    return true;
  },




  /* ----------------------------------------------- */
  /* ------------------- Date ---------------------- */
  /* ----------------------------------------------- */
  formatISODate(data) {
    // Converto yyyy-MM-dd => dd/MM/yyyy
    // NOTA: la data deve essere passata in formato ISO (.toISOString())
    if (!data) return null;

    // Ricavo solo la data (primi 10 caratteri)
    data = data.substr(0, 10)

    const [year, month, day] = data.split("-");
    return `${day}/${month}/${year}`;
  },

  formatISODateTime(data) {
    // Converto yyyy-MM-dd => dd/MM/yyyy
    // NOTA: la data deve essere passata in formato ISO (.toISOString())
    if (!data) return null;

    // Ricavo solo la data (primi 10 caratteri)
    let ora = data.substr(11, 8)
    data = data.substr(0, 10)
    const [year, month, day] = data.split("-");
    const [hour, mins, secs] = ora.split(":")
    return `${day}/${month}/${year} ${hour}:${mins}:${secs}`;
  },

  formatITDateToISO(date) {
    // Converto dd/MM/yyyy => yyyy-MM-dd
    if (!date) return null;

    const [day, month, year] = date.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  },

  formatDate_IT(d) {
    // Converto Tue Jul 02 2019 17:17:35 GMT+0200 => dd/MM/yyyy

    let year = "" + d.getFullYear();

    let month = "" + (d.getMonth() + 1);
    if (month.length == 1) {
      month = "0" + month;
    }

    let day = "" + d.getDate();
    if (day.length == 1) {
      day = "0" + day;
    }

    return day + "/" + month + "/" + year;
  },


  getDateIso(date) {
    let tzoffset = date.getTimezoneOffset() * 60000;
    let localISODate = (new Date(date - tzoffset)).toISOString().slice(0, -1);
    return localISODate.substr(0, 10)
  },

  getDateTimeIso(date) {
    let tzoffset = date.getTimezoneOffset() * 60000;
    let localISODate = new Date(date - tzoffset).toISOString().slice(0, -1);
    return localISODate;
  },

  getYear(data) {
    return (new Date(data).getFullYear())
  },
  getYear() {
    return (new Date().getFullYear())
  },

  getMonth(data) {
    return (new Date(data).getMonth()) + 1
  },
  getMonth() {
    return (new Date().getMonth()) + 1
  },

  getMonths() {
    var monthNames = ["Gennaio", "Febbario", "Marzo", "Aprile", "Maggio", "Giugno",
      "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];

    return monthNames
  },

  getShortMonths() {
    let m = [
      "gen",
      "feb",
      "mar",
      "apr",
      "mag",
      "giu",
      "lug",
      "ago",
      "set",
      "ott",
      "nov",
      "dic",
    ];
    return m;
  },

  getWeek(date) {

    // var date = new Date(this.getTime());
    date.setHours(0, 0, 0, 0);
    // Thursday in current week decides the year.
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    // January 4 is always in week 1.
    var week1 = new Date(date.getFullYear(), 0, 4);
    // Adjust to Thursday in week 1 and count number of weeks from date to week1.
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
      - 3 + (week1.getDay() + 6) % 7) / 7);
  },

  getDaysInMonth(year, month) {
    let date = new Date(year, month, 0);
    return date.getDate();
  },

  DateFormat(d) {
    let year = "" + d.getFullYear();
    let month = "" + (d.getMonth() + 1);
    if (month.length == 1) {
      month = "0" + month;
    }
    let day = "" + d.getDate();
    if (day.length == 1) {
      day = "0" + day;
    }
    let hour = "" + d.getHours();
    if (hour.length == 1) {
      hour = "0" + hour;
    }
    let minute = "" + d.getMinutes();
    if (minute.length == 1) {
      minute = "0" + minute;
    }
    let second = "" + d.getSeconds();
    if (second.length == 1) {
      second = "0" + second;
    }

    return day + "/" + month + "/" + year + " " + hour + ":" + minute + ":" + second;
  },


  dateDiffDay(dataInizio, dataFine) {
    let date1 = new Date(dataInizio);
    let date2 = new Date(dataFine);

    // To calculate the time difference of two dates
    let Difference_In_Time = Math.abs(date2.getTime() - date1.getTime());

    // To calculate the no. of days between two dates
    let Difference_In_Days = Math.ceil(
      Difference_In_Time / (1000 * 3600 * 24)
    );

    return Difference_In_Days
  },



  /* ----------------------------------------------- */
  /* ------------------- Stringhe ------------------ */
  /* ----------------------------------------------- */
  replaceAll(str, valCerca, valReplace) {
    // escape regexp special characters in search string
    valCerca = valCerca.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')

    return str.replace(new RegExp(valCerca, 'g'), valReplace);
  },

  remove_first_character(element) {
    return element.substr(1, element.length)
  },

  remove_last_character(element) {
    return element.substr(0, element.length - 1)
  },

  trimAll(text) {
    return text.toString().replace(/\s/g, '')
  },

  getValuesBetweenDelimeters(whole_str, str1, str2) {
    return whole_str.substring(
      whole_str.indexOf(str1) + str1.length,
      whole_str.indexOf(str2)
    );

  },


  /* ----------------------------------------------- */
  /* ----------------.--- Update ---------------.--- */
  /* ----------------------------------------------- */
  async checkUpdate(url, autoUpdate) {

    if (url.length == 0) return false;

    try {
      // NOTA: nel caso di file statico aggiungo l'ora altrimenti prenderebbe il file dalla cache
      //       se invece nell'url passo una chiamata api non faccio nulla
      if (url.endsWith(".html")) {
        // NOTA: aggiungo l'ora altrimenti prenderebbe il file dalla cache
        url += location.href.indexOf("?") == -1 ? "?" : "&"
        url += "timeStamp=" + (new Date()).getTime();
      }


      let res = await fetch(url);

      let str = await res.text();


      let strFind = "/js/app.";

      // Cerco la versione
      let start = str.indexOf(strFind);
      if (start == -1)
        return false

      let hash = str.substring(
        start + strFind.length,
        start + strFind.length + 8
      );

      let vers = localStorage.getItem('version');

      // Controllo versione locale con quella di webpack
      if (vers && vers !== hash) {
        // Controllo autoaggiornamento
        if (autoUpdate) {
          localStorage.removeItem("version");
          window.location.reload();
        }
        return true
      } else {
        localStorage.setItem('version', hash);
      }
    } catch (error) {
      console.log(error);
    }

    return false
  }

}